import React, { useCallback, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import ModalOpacity from 'ModalOpacity.js';
import AccountPayments from 'AccountPayments.js';
import UseToggle from 'UseToggle.js';
import { translation } from 'utilsHelper';
import { getLanguageCookie } from 'cookiesHelper';
import PaymentIcon from 'exchange_alt.svg';
import { toggleSessionExtensionModal } from 'authActions.js';
import S from 'StyledInstantWinGamesTopTab.js';

const InstantWinGamesTopTab = ({ brandData, user }) => {

  const { login = '', balance = 0 } = user ?? {};
  const isCustomerTypeIWG = login?.startsWith("session_user_") || false;

  const paymentData = {
    currencyCode: brandData?.mainCurrency,
    countryCode: brandData?.countryCode,
    lang: getLanguageCookie(),
  }
  
  const dispatch = useDispatch()
  
  const [showPaymentModal, togglePaymentModal] = UseToggle(false);
  
  const handlePaymentWidgetClose = useCallback(() => {
    togglePaymentModal(false)
  }, [togglePaymentModal])

  useEffect(() => {
    window.addEventListener("paymentWidgetModalClose", handlePaymentWidgetClose)
    return () => {
      window.removeEventListener("paymentWidgetModalClose", handlePaymentWidgetClose)
    }
  }, [])

  // Automatically log out IWG user, if balance is equal 0
  useEffect(() => {
    if (isCustomerTypeIWG && balance === 0) {
      if (showPaymentModal){
        togglePaymentModal(false)
      }
      dispatch(toggleSessionExtensionModal({isOpen: true, sessionClosed: true}))
    }
  }, [isCustomerTypeIWG, balance])

  return brandData ? (
    <S.InstantWinGamesTopTab>
      <ModalOpacity
        isOpen={showPaymentModal}
        toggleOpen={() => togglePaymentModal()}
        flexDirectionBody="column"
        title={translation('instantWinGames_deposit')}
        titleIcon={PaymentIcon}
        titleIconWidth="20px"
        titleIconHeight={null}
        titleFontSize="14px"
        titleColor="white"
        closeIconColor="white"
        headerPadding="1.25rem"
        backgroundHeader="#009A3F"
        padding="0px"
      >
        <S.PaymentBalanceInfo>
          <S.PaymentSessionWrapper isSessionActive={!!user}>
            <span>{!!user ? translation('session_active') : translation('session_deactive')} - </span>
            <span>{login ? translation('session_user', { id: login }) : translation('deposit_to_play')}</span>
          </S.PaymentSessionWrapper>
          <S.PaymentBalanceWrapper>
            <span>{translation('balance')}:</span>
            <S.PaymentBalanceBox>
              {balance.toFixed(2)}
            </S.PaymentBalanceBox>
            <S.InfoIcon>i</S.InfoIcon>
          </S.PaymentBalanceWrapper>
        </S.PaymentBalanceInfo>
        <AccountPayments {...paymentData} />
      </ModalOpacity>

      <S.BalanceWrapper className="balance">
        <span>{translation('balance')}</span>
        <S.BalanceBox>{balance.toFixed(2)}</S.BalanceBox>
        <S.DepositButton onClick={() => togglePaymentModal()}>
          <S.DepositIcon dangerouslySetInnerHTML={{ __html: PaymentIcon }} />
          {translation('instantWinGames_deposit')}
        </S.DepositButton>
      </S.BalanceWrapper>
    </S.InstantWinGamesTopTab>
  ) : null;
};

const mapStateToProps = ({ Auth: { brandData, user } }) => {
  return {
    brandData,
    user
  };
};

export default connect(mapStateToProps, null)(InstantWinGamesTopTab);
